<template>
	<div class="orderConfrim">
		<dialog-template 
            :append-to-body='true' 
            :visible.sync="dialogVisible"
            :width="width" 
            :headerTitle="'订单确认'"
        >
			<div class="content">
				<div class="list">
					<div>
                        <p>购买服务</p>：
                    </div>
					<div>零售{{ getName }}{{ getFeeName }}</div>
				</div>
                <div class="list">
					<div>
                        <p>单价</p>：
                    </div>
					<div><span class="symbol">¥</span>{{ +(primer.price) }}/年</div>
				</div>
                <!-- 购买时长 -->
                <div class="time-block content">
                    <div class="block-1 list">
                        <div class="block-1-left">
                            <p>购买时长</p>：
                        </div>
                        <div class="block-1-right">
                            <!-- 试用 或者购买都没有 isShiYong false-->
                            <span
                                v-if="!isShiYong && serveInfo === 1"
                                @click="currentId = -1"
                                :class="currentId === -1 ? 'active' : ''">{{ remainDay }}天</span>
                            <!-- <span>1年</span> -->
                            <!-- 续费对购买进行限制 -->
                            <!-- (最大年限 - 已购买年限) > 当前可购买的年数 -->
                            <template
                                v-if="serveInfo === 0"
                                v-for="(item, index) in count"
                            >
                                <span
                                    :key='index'
                                    :class="currentId === index ? 'active' : ''"
                                    v-if=" isShiYong ? true :(maxYears - ((remainDay) / 365)) >= item.expired_date"
                                    @click="currentId = index"
                                    >{{ item.expired_date }}年
                                    <span class="discountBg" v-if="item.discount_percent > 0">{{ item.discount_percent }}折</span>
                                </span>
                            </template>
                            <!-- 升级对购买进行限制 -->
                            <template
                                v-if="serveInfo === 1"
                                v-for="(item, index) in count"
                            >
                                <span
                                    :key='index'
                                    :class="currentId === index ? 'active' : ''"
                                    @click="currentId = index"
                                    v-if="remainDay < item.expired_date * 365"
                                    >{{ item.expired_date }}年
                                    <span class="discountBg" v-if="item.discount_percent > 0">{{ +item.discount_percent }}折</span>
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
                <template v-if="isHaveActivity">
                    <p class="expire-time" v-if="!(serveInfo === 0) && currentId === -1">当前版本剩余{{ remainDay }}天，{{ expireDay(this.remainDay)}}到期</p>
                    <p class="expire-time" v-if="(serveInfo === 1) && currentId >= 0">{{ expireDay( 365 * this.count[currentId].expired_date )}}到期</p>
                    <div class="list mt-10" v-if="!(serveInfo === 0) ">
                        <div>
                            <p>抵扣金额</p>：
                        </div>
                        <div>
                            <span>-¥{{ +deductionMoney }}</span>
                            <el-tooltip effect="dark"
                                placement="top-start">
                                <div slot="content" style="line-height: 18px">
                                    <p>{{ gerOriginName }}还剩{{ remainDay }}天，可抵扣{{ +deductionMoney }}元</p>
                                </div>
                                <i class="question-icon"/>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="content">
                        <div class="list mt-10" v-if="currentId >=0 && count[currentId].discount_percent">
                            <div>
                                <p>限时{{ +count[currentId].discount_percent }}折</p>：
                            </div>
                            <div class="discount">-¥{{ +orderDiscountPrice }}</div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="list" v-if="!(serveInfo === 0)">
                            <div>
                                <p>备注</p>：
                            </div>
                            <div class="remark">{{ remark }}</div>
                        </div>
                    </div>
                </template>
				<div class="content">
                    <div class="list mt-10">
                        <div>
                            <p>订单总价</p>：
                        </div>
                        <div class="accountPay"><span class="symbol">¥</span>{{ +(orderPrice) }}</div>
                    </div>
                </div>
			</div>

			<div class="footer" slot="footer">
				<el-button type="primary" size="medium" @click="immediatelyToApply">{{confrimText}}</el-button>
				<el-button type="default" size="medium" @click="dialogVisible = false">{{cancelText}}</el-button>
			</div>
		</dialog-template>
	</div>
</template>

<script>
import { mapState } from "vuex"
import store from '@/store/index'
import domain from '@/config/domain'
import { queryString, fixNum } from '@/utils'
import { editionJudge } from '../../../utils/editionJudge'
import $fetch from '@/api'
import dayjs from 'dayjs'
import { openMessage } from '../../../utils/system'
import { Message } from 'element-ui'

export default {
	data() {
		return {
            dialogVisible: false,
            currentId: -1,
            lock: false
		}
    },
	props: {
		width: {
			type: String,
			default: "400px"
        },
		confrimText: {
			type: String,
			default: "立即支付"
        },
		cancelText: {
			type: String,
			default: "取消"
        },
        isShiYong: {
            type: Boolean,
            default: true
        },
        type: {
            type: Number,
            default: 0
        },
        count: { // 可付费折扣信息
            type: Array,
            default: []
        },
        serveInfo: { // 服务信息， 续费 还是升级
            type: Number
        },
        remark: {  // 备注信息
            tepe: String,
            default: ''
        },
        isHaveActivity: {
            type: Boolean,
            default: false
        },
        maxYears: {
            type: Number,
            default: 0
        }, // 最大价格
        originItemPrice: Object, // 原版本的价格
        remainDay: String | Number, // 当前日期
        primer: Object // 当前版本的价格， fee_code
    },
    computed: {
	    shopInfo() {
            return store.state.shop.shopInfo
        },
      
        // 抵扣金额   （ 原版本价格 / 365 天 * 剩余天数 ）
        deductionMoney() { 
            return (( + this.originItemPrice.price  / 365 ) * this.remainDay).toFixed(2)
        },

          // 计算折扣价格优惠
        orderDiscountPrice() {
            const discountObj =  this.count[this.currentId]
            if (this.currentId >= 0 ) {
                if ( this.isShiYong ) {
                    console.log(this.currentId, 'churrreee')
                    if (discountObj.discount_percent > 0 ) {
                        const allMoeny = discountObj.expired_date * this.primer.price
                        return (allMoeny - (allMoeny * discountObj.discount_percent * 0.1)).toFixed(2)
                    } else {
                        return 0
                    }
                    // return this.count[this.currentId].discount_percent ?  ((this.primer.price * 0.1)* this.count[this.currentId].discount_percent).toFixed(2) : 0
                }
                // 非试用并且是升级
                if ( !this.isShiYong && this.serveInfo === 1) {
                    const allMoney = discountObj.expired_date * this.primer.price - this.deductionMoney
                    // 折扣大于0才计算
                    if (discountObj.discount_percent > 0) {
                        // console.log(this.deductionMoney, 'deductionMoney')
                        // （订单总价 - 抵扣价格）- （订单总价 - 抵扣价格）* 折扣 
                        
                        return (allMoney - (allMoney * discountObj.discount_percent * 0.1)).toFixed(2)
                    } else {
                        return 0
                    }
                
                } else { // 非试用且是续费
                    // const discountObj =  this.count[this.currentId]
                    const allMoeny = discountObj.expired_date * this.primer.price
                    if (discountObj.discount_percent > 0) {
                        return (allMoeny - (allMoeny * discountObj.discount_percent * 0.1)).toFixed(2)
                    } else  {
                        // return allMoeny.toFixed(2)
                        return 0
                    }
                }
            } else {
                return 0
            }

        },

        // 计算到期日期
        // expireDay() {
        //     // return  dayjs().format('YYYY-MM-DD')
        //     return dayjs().add(this.remainDay, 'day').format('YYYY-MM-DD')
        // },

        // 计算订单总价 
        orderPrice() {
            console.log(this.currentId, ' console.log(this.isShiYong)')
            if ( this.isShiYong ) {
                if (this.currentId >= 0) {        
                    // 试用的价格计算  （总价）      
                    return this.count[this.currentId].discount_percent > 0 ?  ((this.primer.price * 0.10)* this.count[this.currentId].discount_percent * this.count[this.currentId].expired_date).toFixed(2) : this.primer.price * this.count[this.currentId].expired_date
                }
            }
            // 非试用并且是升级( 需要减去抵扣价格)
            if ( !this.isShiYong && this.serveInfo === 1) {
                const discountObj =  this.count[this.currentId]
                
                // return (this.primer.price * (discountObj.discount_percent * discountObj.expired_date  - this.deductionMoney ) * 0.10).toFixed(2)
                if ( this.currentId === -1 ) {
                    // 计算当前每一天可以多少钱   1年的价钱 / 365  * remainDay( 剩余的天数) - 抵扣金额
                    
                    return ((this.primer.price / 365 * this.remainDay) - this.deductionMoney).toFixed(2)
                }
                if (this.currentId >= 0  && Object.keys(discountObj).length > 0) {
                    // 总价 = 单价 * 年数 * 折扣 - 抵扣金额 (原先的公式)
                    // if (discountObj.discount_percent > 0) {
                    //     return ((this.primer.price * (discountObj.discount_percent * discountObj.expired_date) * 0.10) - this.deductionMoney) .toFixed(2)
                    // } else {
                    //     return ((this.primer.price * discountObj.expired_date)  - this.deductionMoney).toFixed(2)
                    // }
                    // 总价 =( 单价 * 年数 - 抵扣金额 )  - ( 单价 * 年数 - 抵扣金额 ) * 折扣
                    if (discountObj.discount_percent > 0) {
                        // orderDiscountPrice
                        return (((this.primer.price * discountObj.expired_date) - this.deductionMoney ) - this.orderDiscountPrice).toFixed(2)
                        // const tempTotalPrice = (this.primer.price * discountObj.expired_date)  - this.deductionMoney
                        return ( tempTotalPrice - tempTotalPrice * discountObj.discount_percent * 0.01).toFixed(2)
                    } else {
                        return ((this.primer.price * discountObj.expired_date)  - this.deductionMoney).toFixed(2)
                    }
                    
                }
            } else { // 非试用且是续费
                const discountObj =  this.count[this.currentId]
                if (this.currentId >= 0  && Object.keys(discountObj).length > 0) {
                    // 处理折扣大于0
                    if (discountObj.discount_percent > 0) {
                        return (this.primer.price * (discountObj.discount_percent * discountObj.expired_date) * 0.10).toFixed(2)
                    } else {
                        return (this.primer.price * discountObj.expired_date ).toFixed(2)
                    }
                }
            }
        
        },

        getName() {
            return ['标准版', '专业版', '旗舰版'].find((_, i) => i === this.type)
        },
        gerOriginName() {
            return ['标准版', '专业版', '旗舰版'].find((_, i) => i === editionJudge.getShopVersion)
        },

        getFeeName() {
            return  '年服务费'
        }
    },

	methods: {
		open() {
           
            if (!this.isShiYong && this.serveInfo === 1) {
                this.currentId = -1
            } else {
                this.currentId = 0 
            }
            if (this.serveInfo !== 1) { // 判断是否能续费
                console.log(this.remainDay)
                console.log(this.count)
                // debugger
                const arr = this.count.map( item =>  item.expired_date * 365 )
                // console.log(arr)
                const flag = arr.some( item => {
                    return item > this.remainDay
                })
                // const falg1 = this.yearsArrActivity.every( item => item.expired_date > (this.maxYears - ( remainDay / 365) )) // 数组里面的年限🉐️小于可购买的年数
                const flag1 = this.count.every( item => item.expired_date > (this.maxYears -(this.remainDay / 365)) )
                if (!flag || flag1 ) return openMessage(Message.error, '当前剩余有效期充足，暂不允许续费')
            }
            this.dialogVisible = true
            
        },

        immediatelyToApply() {
            console.log('2222')
            // 试用状态
            let params = {}
            if ( this.isShiYong ) {
                let discountDercent = undefined
                if (this.currentId >= 0) {
                    discountDercent = this.count[this.currentId].discount_percent ? +this.count[this.currentId].discount_percent : undefined
                }
                params = {
                    fee_code: this.primer.fee_code,
                    count: this.currentId >=0 ? this.count[this.currentId].expired_date : 0,
                    discount_price: this.orderDiscountPrice ? this.orderDiscountPrice : undefined,
                    discount_percent: discountDercent
                }
            }
            // 非试用，但是续费
            if (!this.isShiYong && this.serveInfo === 0) {
                let discountDercent = undefined
                if (this.currentId >= 0) {
                    discountDercent = this.count[this.currentId].discount_percent ? +this.count[this.currentId].discount_percent : undefined
                }
                // debugger
                params = {
                    fee_code: this.primer.fee_code,
                    count: this.currentId >=0 ? this.count[this.currentId].expired_date : 0, // 年数
                    expired_date: this.currentId === -1 ? this.remainDay : undefined, // 剩余天数
                    discount_price: this.orderDiscountPrice ? +this.orderDiscountPrice : undefined,
                    discount_percent: discountDercent
                }
            }
            if (!this.isShiYong && this.serveInfo === 1 ) { // 非试用且升级
                let discountDercent = undefined
                if (this.currentId >= 0) {
                    discountDercent = this.count[this.currentId].discount_percent ? +this.count[this.currentId].discount_percent : undefined
                }
                console.log(this.currentId)
                params = {
                    fee_code: this.primer.fee_code,
                    count: this.currentId >=0 ? this.count[this.currentId].expired_date : 0, // 年数
                    deduction_price: this.deductionMoney ? this.deductionMoney : undefined,
                    remark: this.remark,
                    deduction_content: `${this.gerOriginName}还剩${this.remainDay}天，可抵扣${this.deductionMoney}元。`,
                    expired_date: this.currentId === -1 ? this.remainDay : undefined, // 剩余天数
                    discount_percent: discountDercent,
                    discount_price: this.orderDiscountPrice ? +this.orderDiscountPrice : undefined
                }
            }

            if (this.lock) return
            this.lock = true
            $fetch.post({
                url: '/valueaddedservices/checkandcreatepaymentrecord',
                params
            }).then( res => {
                console.log(res)
                let params = {
                    fee_code: this.primer.fee_code,
                    shop_id: this.shopInfo.id,
                    shop_type: 'new_ls',
                    fee_record_id: res.fee_record_id,
                    shop_super_admin_passport_id: this.shopInfo.creator.passport_id,
                    purchase_type: 'new_ls'
                }
                const path = '/#/main/paymentCenter'
                console.log(domain.center + path + queryString(params, true))
                window.location.href = domain.center + path + queryString(params, true)
                setTimeout(() => {
                    this.lock = false
                }, 1000)
            }).catch( e => {
                openMessage(Message.error, e.message || '订单创建失败')
                this.lock = false
            })
            
        },

        computendYears(item) {
            const arr = item.map( item => {
                // console.log(expired_date)
                return item.expired_date
            })
            let max = Math.max.call(Math, ...arr)
            const years =( max * 365 -  this.remainDay) / 365 

            return years
        },
        
        computedMaxyears(item) {
             const arr = item.map( item => {
                // console.log(expired_date)
                return item.expired_date
            })
            let max = Math.max.call(Math, ...arr)
            return max
        },

        expireDay(day) {
            // return  dayjs().format('YYYY-MM-DD')
            return dayjs().add(day, 'day').format('YYYY-MM-DD')
        },




        // discountInfo(item) {
        //     this.count.forEach(el => {
        //         if (el.expired_date === item) {
        //             return 
        //         }
        //     })
        // }
    }
}
</script>

<style lang='scss' scoped>
.content {
    .list {
        margin-bottom: 10px;
        display: flex;
        font-size: 14px;

        div {
            &:nth-of-type(1) {
                display: flex;
                width: 75px;
                line-height: 20px;
                color: #666;
                text-align-last: justify;

                > p {
                    width: 70px;
                }
            }

            &:nth-of-type(2) {
                font-weight: 500;
                line-height: 20px;
                color: #333;
            }
        }

        .price {
            color: #FF533A!important;
            font-size: 16px!important;
        }  
        .discount {
            color: #FF533A!important;
            font-size: 14px;
        }

        .accountPay {
            color: #009688!important;
            font-weight: bold;
            font-size: 16px;
        }

        .symbol {
            margin-right: 3px;
            font-size: 12px;
        }

        .remark {
            color: #333!important;
        }
    }

    .time-block {
          .block-1 {
            display: flex;
            

            .block-1-left {
                // line-height: 20px;
                 padding-top: 5px;
                >p {
                    color: #666;
                    // padding-top: 5px;
                    text-align-last: justify;
                }
            }       

            .block-1-right {
                display: flex;

                > span {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 60px;
                    height: 36px;
                    background: #FFFFFF;
                    border: 1px solid #DDDDDD;
                    border-radius: 5px;
                    margin-left: 12px;
                    cursor: pointer;

                    &:first-child {
                        margin: 0;
                    }
                }

                .discountBg {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: -10px;
                    right: -9px;
                    width: 46px;
                    height: 16px;
                    // background-color: red;
                    position: absolute;
                    color: #fff;
                    font-size: 14px;
                    font-weight: bold;
                    background: url('~@/assets/images/discountBg.svg') no-repeat;
                }

                .active {
                    background: rgba(0,150,136,0.10);
                    border: 1px solid #009688;
                    font-size: 14px;
                    color: #009688;
                    border-radius: 5px;
                }
            }
          }
                
    }

    .expire-time {
        font-size: 12px;
        color: #999;
        margin-left: 74px;
        padding-top: 4px;
    }


    .question-icon {
        line-height: 1;
        font-size: 14px;
        color: #fff;
        margin-left: 4px;

        &::before {
            content: '?';
            display: inline-block;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            font-weight: normal;
            background: #d0d0d0;
            border-radius: 50%;
        }
    }
}
.footer {
	text-align: center;
}
</style>